import React, { useState } from 'react';
import { Drawer } from 'antd';
import { setDisplayMobileMenu } from 'reduxStore/slices/contact.slice';
import { useAppDispatch, useAppSelector } from 'reduxStore/hooks';
import headerLogo from 'assets/images/logos/PTYMGMTLogo.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setDisplayModal } from 'reduxStore/slices/contact.slice';
import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import { AppstoreOutlined, BranchesOutlined, DotChartOutlined } from '@ant-design/icons';
import { PiPlantFill } from 'react-icons/pi';
import { MdSell } from 'react-icons/md';

export default function MenuMovil() {
    const dispatch = useAppDispatch();
    const displayMobileMenu = useAppSelector((state) => state.contactSlice.displayMobileMenu);
    const { t } = useTranslation();

    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
    type MenuItem = Required<MenuProps>['items'][number];

    const items: MenuItem[] = [
        {
            key: 'item1',
            label: <Link to="/">{t('menu.home')}</Link>,
        },
        {
            key: 'item2',
            label: (
                <Link
                    to="#"
                    onClick={() => {
                        dispatch(setDisplayModal(true));
                        //onClose();
                    }}
                >
                    {t('menu.contact')}
                </Link>
            ),
        },
    ];

    const onClose = () => {
        dispatch(setDisplayMobileMenu(false));
    };

    return (
        <Drawer title="Basic Drawer" onClose={onClose} open={displayMobileMenu}>
            <div
                className="nv__header__logo nv__header__logo--mobile"
                onClick={() => {
                    onClose();
                }}
            >
                {/* <Link to="/#home">
                    <img src={headerLogo} alt="Logo Narval white blue" />
                </Link> */}
            </div>

            <section>
                {/* <ActionButton
                    text={t('menu.contact')}
                    type="rounded"
                    onClick={() => {
                        onClose();
                        dispatch(setDisplayModal(true));
                    }}
                /> */}

                <Menu
                    defaultSelectedKeys={['1']}
                    mode="inline"
                    theme="dark"
                    inlineCollapsed={collapsed}
                    items={items}
                    onClick={() => {
                        onClose();
                        dispatch(setDisplayMobileMenu(false));
                    }}
                />
            </section>
        </Drawer>
    );
}
